import { Divider } from '@mui/material';
import React, { useState } from 'react';
import {
  Datagrid,
  DateField,
  List,
  ListContextProvider,
  NumberField,
  SimpleForm,
  TextField as AdminTextField,
  useListController,
} from 'react-admin';
import { useHistory } from 'react-router';
import CustomerAutoCompleteInput from '../order/CustomerAutoCompleteInput';
import { CUSTOMER, ORDER } from '../order/Order.string';
import { Customer } from '../order/Order.type';
import { convToStringFromDateForYearMonth } from '../util/date';
import CommonSettlementDatePicker from './CommonSettlementDatePicker';
import CustomerOrderSettlementShow from './CustomerOrderSettlementShow';

export default function CustomerOrderSettlementList() {
  const listController = useListController({
    resource: 'order',
    basePath: 'order',
  });

  const history = useHistory();

  const [customer, setCustomer] = useState<Customer>();

  const [filter, setFilter] = useState<{
    createdAt?: string;
    customer?: { id?: number };
  }>({ createdAt: convToStringFromDateForYearMonth(new Date()) });

  const onChangeDate = (value: Date | null | undefined) => {
    setFilter({
      ...filter,
      createdAt: convToStringFromDateForYearMonth(value),
    });
  };

  return (
    <div>
      <Divider sx={{ marginTop: 3 }} />
      <SimpleForm
        style={{ margin: '0 !important', padding: '0 !important' }}
        onSubmit={() => {}}
        toolbar={false}
      >
        <CommonSettlementDatePicker
          value={filter.createdAt}
          onChange={onChangeDate}
        />
        <CustomerAutoCompleteInput
          onSelect={(cstm: Customer) => {
            if (cstm.id) {
              setFilter({ ...filter, customer: { id: cstm.id } });
              setCustomer(cstm);
            } else {
              let temp = { ...filter };
              delete temp.customer;
              setFilter(temp);
              setCustomer(undefined);
            }
          }}
        />
      </SimpleForm>

      <Divider />
      <CustomerOrderSettlementShow
        date={filter.createdAt}
        customer={customer}
      />
      <Divider />
      <ListContextProvider value={listController}>
        <List
          hasCreate={false}
          title={`고객사 주문 정산 ${
            customer?.name ? `: ${customer?.name}` : ': 전체'
          }`}
          filter={filter}
          basePath={listController.basePath}
          resource={listController.resource}
          perPage={30}
          bulkActionButtons={false}
        >
          <Datagrid
            rowClick={(id, basePath, record) => {
              history.push(`/order/${record.id}`);
              return '';
            }}
          >
            <DateField
              cellClassName='react-admin-list-column-100px'
              label={ORDER.CREATED_AT}
              source='createdAt'
            />
            <AdminTextField
              cellClassName='react-admin-list-column-100px'
              label={ORDER.ID}
              source='id'
            />
            <AdminTextField label={CUSTOMER.NAME} source='customer.name' />
            <DateField
              cellClassName='react-admin-list-column-100px'
              label={ORDER.DUE_DATE}
              source={'shipDate'}
            />
            <NumberField
              cellClassName='react-admin-list-column-100px'
              label={ORDER.TOTAL_AMOUNT}
              source={'totalAmount'}
            />
            <NumberField
              cellClassName='react-admin-list-column-150px'
              label={ORDER.DISPLAY_GROSS_PRICE}
              source={'displayGrossPrice'}
              options={{ style: 'currency', currency: 'KRW' }}
            />
          </Datagrid>
        </List>
      </ListContextProvider>
    </div>
  );
}
